module.exports = __webpack_public_path__ + "static/media/speedweaver-light.0e542799.svg";